import React from 'react';
import { Anchor } from 'antd';
import { AnchorLinkProps as AnchorLinkCopyProps } from 'antd/lib/anchor/AnchorLink';

export type AnchorLinkProps = AnchorLinkCopyProps;

const ProAnchorLink: React.FC<AnchorLinkProps> = (props) => {
  return (
    <Anchor.Link {...props} />
  );
};

export default ProAnchorLink;
